export default __webpack_public_path__ + "static/media/indian-navy.e0a9b4a0.jpeg";